<template>
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <span class="img-area"><img src="@/assets/images/common/artwork_idle_close_3d.gif" /></span>
        <div class="lyr-title">{{ $t('Modal.CloseModal.msg1') }}</div>
        <div class="ft-point">
          {{ $t('Modal.CloseModal.msg2') }}
        </div>
        <div class="lyr-txt">{{ $t('Modal.CloseModal.msg3') }}</div>
      </div>
      <div class="layer__body">
        <div class="box-close">
          <span class="ico-clock">{{ $t('Modal.CloseModal.msg4') }}</span>
          <span class="ft--3xlg">{{modalOpenTime}} ~ {{modalCloseTime}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'closeModal',
  data() {
    return {
      modalOpenTime : "",
      modalCloseTime : "",
    };
  },
  props: {
    imgPath : String,
    openTime : String,
    closeTime : String,
  },
  methods: {},
  mounted() {
    this.modalOpenTime   = this.openTime.substr(0, 2) + ":" + this.openTime.substr(2, 2) 
    this.modalCloseTime  = this.closeTime.substr(0, 2) + ":" + this.closeTime.substr(2, 2)
  },
};
</script>

<style src='@/assets/css/user/common.css' scoped></style>
<style scoped>
</style>
